import { useCallback } from 'react';
import { useMarketplaceModal } from './useMarketplaceModal';
export function useMarketplaceListingModal(props = {}) {
  const {
    open: baseOpen,
    close
  } = useMarketplaceModal(Object.assign({
    modalType: 'LISTING'
  }, props));
  const open = useCallback(listingSlug => baseOpen({
    listingSlug
  }), [baseOpen]);
  return {
    open,
    close
  };
}